import axios from "axios";
export default {
  methods: {
    callRequestService(
      vueComponent,
      config,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      this.callService(
        vueComponent,
        () => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("callRequestService - config", config);
          return axios.request(config);
        },
        promiseMethod,
        errorHandler,
        loadingMessage
      );
    },

    callGetService(
      vueComponent,
      serviceURL,
      config,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      // console.log("callGetService", vueComponent, config);
      this.callService(
        vueComponent,
        () => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("callGetService", serviceURL);
          return axios.get(serviceURL, config);
        },
        promiseMethod,
        errorHandler,
        loadingMessage
      );
    },

    callDeleteService(
      vueComponent,
      serviceURL,
      config,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      this.callService(
        vueComponent,
        () => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("callDeleteService", serviceURL);
          return axios.delete(serviceURL, config);
        },
        promiseMethod,
        errorHandler,
        loadingMessage
      );
    },

    callHeadService(
      vueComponent,
      serviceURL,
      config,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      this.callService(
        vueComponent,
        () => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("callHeadService", serviceURL);
          return axios.head(serviceURL, config);
        },
        promiseMethod,
        errorHandler,
        loadingMessage
      );
    },

    callOptionsService(
      vueComponent,
      serviceURL,
      config,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      this.callService(
        vueComponent,
        () => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("callOptionsService", serviceURL);
          return axios.options(serviceURL, config);
        },
        promiseMethod,
        errorHandler,
        loadingMessage
      );
    },

    callPostService(
      vueComponent,
      serviceURL,
      data,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      // console.log("callPostService", vueComponent, data);
      this.callService(
        vueComponent,
        () => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("callPostService", serviceURL);
          return axios.post(serviceURL, data);
        },
        promiseMethod,
        errorHandler,
        loadingMessage
      );
    },

    callPutService(
      vueComponent,
      serviceURL,
      data,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      // console.log("callPutService", vueComponent, data);
      this.callService(
        vueComponent,
        () => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("callPutService", serviceURL);
          return axios.put(serviceURL, data);
        },
        promiseMethod,
        errorHandler,
        loadingMessage
      );
    },

    callPatchService(
      vueComponent,
      serviceURL,
      data,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      // console.log("callPatchService", vueComponent, data);
      this.callService(
        vueComponent,
        () => {
          if (process.env.VUE_APP_ISDEBUGGING)
            console.log("callPatchService", serviceURL);
          return axios.patch(serviceURL, data);
        },
        promiseMethod,
        errorHandler,
        loadingMessage
      );
    },

    callService(
      vueComponent,
      requestMethod,
      promiseMethod,
      errorHandler,
      loadingMessage
    ) {
      // TODO: do I have a token?
      //localStorage.delete("QFlow_Token");
      //if (localStorage.getItem("QFlow_Token")) {
      //console.log("got the token from locastorage");
      vueComponent.$root.showLoading(loadingMessage);
      requestMethod()
        .then(
          (response) => {
            // vueComponent.$root.hideLoading();
            promiseMethod(response);
          },
          (error) => {
            if (errorHandler) errorHandler(error);
            vueComponent.$root.showError("", error);
          }
        )
        .finally(() => {
          // console.log("callService().finally(this.$store.getters.).");
          vueComponent.$root.hideLoading();
        });
      //}
      // else {
      //   // No QFlow Token
      //   let QFlowToken = "";
      //   let serviceURL = "/Users/Token";
      //   console.log(
      //     "about to call the token url",
      //     serviceURL,
      //     axios.defaults.auth
      //   );
      //   axios
      //     .post(serviceURL, axios.defaults.auth)
      //     .then((response) => {
      //       if (response && response.data) {
      //         QFlowToken =
      //           response.data.APIToken && response.data.APIToken.length > 0
      //             ? response.data.APIToken
      //             : null;
      //         console.log("the response from the api call:", QFlowToken);
      //       }
      //     })
      //     .error((error) => {
      //       console.log("error was thrown:", error);
      //       if (error.response.status == 401) {
      //         // unauthorised wrong credentials
      //         console.log("401 error");
      //       }
      //       if (error.response.status == 403) {
      //         // Forbidden
      //         console.log("403 error");
      //       }
      //       if (error.response.status == 404) {
      //         // Forbidden
      //         console.log("404 error");
      //       }
      //       if (error.response.status == 405) {
      //         // Method not allowed
      //         console.log("405 error");
      //       }
      //     })
      //     .finally(() => {
      //       if (QFlowToken) {
      //         //    localStorage.setItem("QFlow_Token", QFlowToken);
      //       }
      //     });
      // }
    },
  },
};
